import fetch from 'isomorphic-fetch';

import { getHeaders } from '~/utils';

export const extendSaasToken = async ({ globalData }) => {

  const { host, protocol } = window.location;

  return fetch(`${protocol}//${host}/api/status`, {
    headers: getHeaders({
      globalData,
    }),
    method: 'GET',
  })
    .then(res => {
      return res.ok;
    })
    .catch(() => {
      return false;
    });
};
